import Parser, { htmlparser2 } from 'react-html-parser';

let currentText = '';

const customParser = new htmlparser2.Parser(
  {
    onopentag: function (name, attribs) {
      currentText += ' ';
    },
    ontext: function (text) {
      currentText += text;
    },
    onclosetag: function (tagname) {
      currentText += ' ';
    }
  },
  { decodeEntities: true }
);

export function parsePreviewArticle(article) {
  customParser.write(article);
  const res = currentText;
  currentText = '';
  return res;
}

export function parseArticle(article, options = {}) {
  return Parser(article, options);
}

export function isHTML(str) {
  var a = document.createElement('div');
  a.innerHTML = str;

  for (var c = a.childNodes, i = c.length; i--; ) {
    if (c[i].nodeType == 1) return true;
  }

  return false;
}
